module.exports = {
    // basic
    'highlight-remarks-within-results': 'resalta las coincidencias de comentarios en los resultados',
    'return-only-matching-files': 'devolver solo archivos coincidentes',
    'not': 'no',
    'well-add-date': 'pozo añadir fecha',
    'other-properties': 'otras propiedades',
    'property': 'propiedad',
    'add-property': 'agregar propiedad',

    // raw
    'saved-search-new-help': 'Guarde los criterios de búsqueda anteriores.',
    'saved-search-existing-help': 'Guarde los cambios o elimine la búsqueda guardada cargada actualmente.',
    'search-in-remarks': 'Buscar comentarios específicos en las entradas aumentará drásticamente el tiempo de búsqueda. \n ¿Continuar?',
    'search-more-specific-criteria': '<h4>Si tiene más información, puede hacer búsquedas futuras más rápido utilizando criterios más específicos.</h4>',
    'search-has-no-result': 'La búsqueda no encontró resultados.',
    'search-only-matching-files-no-help': 'Todos los archivos se incluirán con cada entrada.',
    'search-filename-help': `
        <b>Nombre de archivo</b> le permite filtrar entradas solo a aquellas que tienen nombres de archivo que <b><i>contienen</i></b> el texto especificado.<br />
        Luego, también puede especificar que solo se devuelva los archivos coincidentes con cada entrada.<br />
        <strong><em>Su búsqueda tardará más en completarse cuando utilice este filtro.</em></strong>
    `,
    'save-search-help-no-columns': 'Se guardarán todos los filtros.',
    'save-search-help': 'Se guardarán todos los filtros y opciones de cuadrícula (selección de columna, archivos por entrada, etc.).',

    // template
    'search-export-limit': (words) => `La exportación está limitada a ${words[0]} resultados. Si necesita exportar resultados, limite sus criterios de búsqueda e intente nuevamente.`,
    'search-export-limit-exceeded': (words) => `El número de resultados es demasiado grande para la exportación. Aplique filtros adicionales para reducir la cantidad de artículos a menos de ${words[0]}.`,
    'search-building-result': (words) => `<h4>La búsqueda encontró ${words[0]} posibles entradas coincidentes. Creando resultados...</h4>`,
    'search-only-matching-files-yes-help': (words) => `Solo los archivos que coincidan con el filtro <b>${words[0]}</b> anterior se incluirán con cada entrada.`,
    'search-filter-help': (words) => `Elija entre las condiciones del filtro, luego haga clic en <b>${words[0]}</b>. Haga clic en <b>${words[1]}</b> para eliminar todos los filtros. Haga clic en <b>${words[2]}</b> para guardar esta búsqueda para uso futuro.`,

};
